'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Fieldset2 = require('./Fieldset');

var _Fieldset3 = _interopRequireDefault(_Fieldset2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Form = (_temp2 = _class = function (_Fieldset) {
  (0, _inherits3.default)(Form, _Fieldset);

  function Form() {
    var _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Fieldset.call.apply(_Fieldset, [this].concat(args))), _this), _this.onSubmit = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(evn) {
        var _this$props, onSubmit, onError, validate, value, errors;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                evn.preventDefault();

                if (!_this.working) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                _this.working = true;
                _this.notifyChildren();

                _this$props = _this.props, onSubmit = _this$props.onSubmit, onError = _this$props.onError, validate = _this$props.validate;
                value = _this.getValue();

                if (!validate) {
                  _context.next = 13;
                  break;
                }

                _context.next = 10;
                return validate(value);

              case 10:
                _context.t0 = _context.sent;
                _context.next = 14;
                break;

              case 13:
                _context.t0 = [];

              case 14:
                _this.errors = _context.t0;
                errors = _this.errors;

                if (!(!errors.length && onSubmit)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 19;
                return onSubmit(value);

              case 19:
                _context.next = 24;
                break;

              case 21:
                if (!(errors && errors.length && onError)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 24;
                return onError(errors, value);

              case 24:

                _this.working = false;
                _this.notifyChildren();

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Form.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    this.setValue(props.value, this, true);
  };

  Form.prototype.getPath = function getPath() {
    return undefined;
  };

  Form.prototype.getOriginalValue = function getOriginalValue() {
    return this.props.value;
  };

  Form.prototype.getForm = function getForm() {
    var parent = this.getParent();
    return parent ? parent.getForm() : this;
  };

  Form.prototype.getErrors = function getErrors(path, exactMatch) {
    var errors = this.errors || [];
    if (!path) {
      return errors;
    }

    var parentPath = path + '.';

    return errors.filter(function (error) {
      if (!error.path) {
        return false;
      }

      if (error.path === path) {
        return true;
      }

      if (!exactMatch && error.path.indexOf(parentPath) === 0) {
        return true;
      }

      return false;
    });
  };

  Form.prototype.hasErrors = function hasErrors(path, exact) {
    return !!this.getErrors(path, exact).length;
  };

  Form.prototype.isValid = function isValid(path, exact) {
    return !this.hasErrors(path, exact);
  };

  Form.prototype.isWorking = function isWorking() {
    return !!this.working;
  };

  Form.prototype.setValue = function setValue(value, component, notifyChildren) {
    this.clearErrors();

    _Fieldset.prototype.setValue.call(this, value, component, notifyChildren);
  };

  Form.prototype.clearErrors = function clearErrors() {
    this.errors = [];
  };

  Form.prototype.getClassName = function getClassName() {
    var _props = this.props,
        className = _props.className,
        tagName = _props.tagName;

    return className || tagName;
  };

  Form.prototype.render = function render() {
    var _props2 = this.props,
        autoComplete = _props2.autoComplete,
        tagName = _props2.tagName,
        children = _props2.children,
        method = _props2.method,
        action = _props2.action;


    var props = tagName === 'form' ? {
      autoComplete: autoComplete,
      method: method,
      action: action,
      className: this.getClassName(),
      onSubmit: this.onSubmit
    } : {
      className: this.getClassName()
    };

    return (0, _react.createElement)(tagName, props, this.processChildren(children));
  };

  return Form;
}(_Fieldset3.default), _class.propTypes = {
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  skipReplace: _propTypes2.default.bool,
  value: _propTypes2.default.object.isRequired,
  method: _propTypes2.default.string,
  action: _propTypes2.default.string,
  autoComplete: _propTypes2.default.string,
  children: _propTypes2.default.node,
  tagName: _propTypes2.default.string.isRequired,
  debounce: _propTypes2.default.number,
  validate: _propTypes2.default.func,
  sameChildren: _propTypes2.default.bool
}, _class.defaultProps = {
  autoComplete: 'off',
  tagName: 'form',
  debounce: 250
}, _class.childContextTypes = {
  fieldset: _propTypes2.default.object.isRequired
}, _class.contextTypes = {
  fieldset: _propTypes2.default.object
}, _temp2);
exports.default = Form;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Form.js
 ** module id = 1274
 ** module chunks = 0
 **/